import React, { Component } from "react";
import { Link } from "react-router-dom";
import { useContext } from "react";
import AccordionContext from "react-bootstrap/AccordionContext";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import axios from "axios";

import {
  Container,
  Row,
  Col,
  Tab,
  Nav,
  Accordion,
  Card,
  Form,
  Button,
} from "react-bootstrap";
import { t } from "i18next";
import { FRONT_BASE_URL,BASE_URL, HEADER_AUTH } from "./App";
import {
  decryptDataFromArray,
  encryptDataToArray,
} from "../helpers/EncryptDecrypt";
import api from "../helpers/api";
function ContextAwareToggle({ children, eventKey, callback }) {
  const currentEventKey = useContext(AccordionContext);

  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey)
  );

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <button
      type="button"
      className={isCurrentEventKey ? "btn active" : "btn unactive"}
      onClick={decoratedOnClick}
    >
      {children}
    </button>
  );
}

export class TopLogo extends React.Component {
  render() {
    return (
      <img
        src="/img/top-logo.webp"
        width="198"
        height="69"
        alt="Hero Housing Finance"
      />
    );
  }
}

export class FooterLogo extends React.Component {
  render() {
    return (
      <img
        src="/img/logo.webp"
        width="198"
        height="69"
        alt="Hero Housing Finance"
      />
    );
  }
}

export class GotQuestions extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      questions: [],
      categories: [],
    };
  }
  componentDidMount() {
    fetch(`${BASE_URL}/get_faq_categories`, { headers: HEADER_AUTH })
      .then((response) => response.ok && response.json())

      .then((result) => this.setState({ categories: result?.data }));
    let api_url = "";
    if (
      localStorage.getItem("language_id") === 0 ||
      localStorage.getItem("language_id") === "0"
    ) {
      api_url = `${BASE_URL}/get_faqs`;
    } else {
      api_url = `${BASE_URL}/get_faqs?language=${localStorage.getItem(
        "language_id"
      )}`;
    }
    fetch(api_url, { headers: HEADER_AUTH })
      .then((response) => response.ok && response.json())

      .then((result) => this.setState({ questions: result?.result }));
  }

  render() {
    const { categories, questions } = this.state;

    return (
      <>
        <section className="section questions-sec">
          <header className="entry-title text-center">
            <h4 className="title-head">{t("Got Questions?")}</h4>
            <p>
              {t(
                "Want to know the answer to that question you have been searching for?"
              )}{" "}
              <br />{" "}
              <strong className="text-primary">
                {t("‘Perfect, because we have got it for you!’")}
              </strong>
            </p>
          </header>

          <Container>
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey={
                categories.length ? categories[0]?.alias : "housing-loan"
              }
            >
              <Row>
                <Col md={3}>
                  <Nav variant="pills" className="flex-column question-tab">
                    {categories.map((cat, i) => (
                      <Nav.Item key={i}>
                        <Nav.Link eventKey={cat.alias}>{t(cat.name)}</Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </Col>
                <Col md={9}>
                  <Tab.Content>
                    {categories.map((cat, i) => (
                      <Tab.Pane eventKey={cat.alias}>
                        <Accordion>
                          {questions?.map((item, index) =>
                            item.category_id === cat.id ? (
                              <Card key={index}>
                                <Card.Header>
                                  <ContextAwareToggle eventKey={index + 1}>
                                    {item.question}
                                  </ContextAwareToggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey={index + 1}>
                                  <Card.Body>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item.answer,
                                      }}
                                    ></div>
                                  </Card.Body>
                                </Accordion.Collapse>
                              </Card>
                            ) : null
                          )}
                        </Accordion>
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Container>

          <div className="cta mt-5 text-center">
            <Link to="/Faqs" className="btn btn-primary">
              {t("View All")}
            </Link>
          </div>
        </section>
      </>
    );
  }
}

export class Requestcallback extends React.Component {
  constructor(props, context) {
    super(props, context);
    // this.divRef = React.createRef();

    this.state = {
      form: {},
      errors: {},
      doVerifyOtp: false,
      cities: [],
      states: [],
      // product: "",
      selected_city: 0,
      selected_state: 0,
      show_loader: false,
      isChecked: false,
      isExpanded: false,
    };
  }
  // componentDidMount() {
  //   let api_url = "";
  //   let api_url_for_state = "";
  //   if (
  //     localStorage.getItem("language_id") === 0 ||
  //     localStorage.getItem("language_id") === "0"
  //   ) {
  //     api_url = api.get("/get_branch_city");
  //     api_url_for_state = api.get("/get_branch_state");
  //   } else {
  //     api_url = api.get(`/get_branch_city?language=${localStorage.getItem("language_id")}`);
  //     api_url_for_state = api.get(`/get_branch_state?language=${localStorage.getItem("language_id")}`);
  //   }
  //   fetch(api_url, { headers: HEADER_AUTH })
  //     .then((response) => response.ok && response.json())
  //     .then((result) => this.setState({ cities: result?.result }));
  //   fetch(api_url_for_state, { headers: HEADER_AUTH })
  //     .then((response) => response.ok && response.json())
  //     .then((result) => this.setState({ states: result?.result }));
  // }
  componentDidMount() {
  let cityUrl = "basic/get_branch_city";
  let stateUrl = "basic/get_branch_state";

  // Add language param if not English (0)
  if (!(localStorage.getItem("language_id") === "0" || localStorage.getItem("language_id") === 0)) {
    const langId = localStorage.getItem("language_id");
    cityUrl += `?language=${langId}`;
    stateUrl += `?language=${langId}`;
  }

  // Get cities
  api
    .get(cityUrl)
    .then((res) => {
      this.setState({ cities: res.data?.result || [] });
    })
    .catch((err) => {
      console.error("Error fetching cities:", err);
    });

  // Get states
  api
    .get(stateUrl)
    .then((res) => {
      this.setState({ states: res.data?.result || [] });
    })
    .catch((err) => {
      console.error("Error fetching states:", err);
    });
}


  toggleContent = (event) => {
    // Prevent default action if it's inside a form
    event.preventDefault();

    this.setState((prevState) => ({
      isExpanded: !prevState.isExpanded,
    }));
  };

  render() {
    const {
      form,
      errors,
      doVerifyOtp,
      cities,
      selected_city,
      states,
      // product,
      selected_state,
      isChecked,
    } = this.state;

    const handleChangeLoanAmount = (field, value) => {
      let cleanedValue = value.replace(/,/g, "");
      let values = cleanedValue
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.setState({
        form: {
          ...form,
          [field]: values.toLocaleString("en-IN"),
        },
      });
    };

    // const scrollToDiv = () => {
    //   if (this.divRef.current) {
    //     const divPosition =
    //       this.divRef.current.getBoundingClientRect().top + window.scrollY;
    //     const offsetPosition = divPosition - 150;

    //     window.scrollTo({
    //       top: offsetPosition,
    //       behavior: "smooth",
    //     });
    //   }
    // };

    // scrollToDiv();

    const checked = () => {
      if (!isChecked) {
        this.setState({ isChecked: true });
      } else {
        this.setState({ isChecked: false });
      }
    };

    const setField = (field, value) => {
      this.setState({
        form: {
          ...form,
          [field]: value,
        },
      });

      if (!!errors[field]) {
        this.setState({
          errors: {
            ...errors,
            [field]: null,
          },
        });
      }
    };

    function isOnlyNumbers(input) {
      const regex = /^\d+$/;
      return regex.test(input);
    }

    const findFormErrors = () => {
      const mobileRegex = new RegExp(/^[5-9]\d{9}$/);
      const mobileCharacterCheckRegex = new RegExp(/^[A-Za-z]{0,}$/);
      const loanAmountRegex = new RegExp(
        /^(?:[5-9]\d{5,6}|1\d{6,7}|200000000)$/
      );
      const nameRegex = new RegExp(/^[A-Za-z]{3,}[ ]{0,1}[A-Za-z]{0,}$/i);
      const emailRegex = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );

      const checkString = new RegExp(/^\d+$/);
      let {
        full_name,
        mobile_number,
        email,
        city,
        state,
        // product,
        loan_amount,
        isChecked,
      } = form;
      if (loan_amount) {
        loan_amount = loan_amount.replace(/,/g, "");
      }
      // if (this.props?.loan_amount) {
      //   loan_amount = this.props?.loan_amount;
      // }
      const newErrors = {};
      if (!nameRegex.test(full_name))
        newErrors.full_name = "Only enter alphabets.";
      if (!full_name || full_name === "")
        newErrors.full_name = "The name field is required.";
      if (!mobileRegex.test(mobile_number))
        newErrors.mobile_number = "Please enter valid number.";
      if (mobileCharacterCheckRegex.test(mobile_number))
        newErrors.mobile_number = "Mobile number must contain only numbers.";
      if (!mobile_number)
        newErrors.mobile_number =
          "Mobile number should contain at least 10 digits.";
      // if (!product) newErrors.product = "Please select product";
      if (!this.state.isChecked) {
        newErrors.isChecked = "This field is required";
      }
      if (email && !emailRegex.test(email))
        newErrors.email = "Invalid email format.";
      if (!city || city === "") newErrors.city = "The city field is required.";
      if (!state || state === "")
        newErrors.state = "The State field is required.";
      if (!isOnlyNumbers(loan_amount))
        newErrors.loan_amount = newErrors.loan_amount = "Invalid loan amount";
      if (loan_amount < 500000 || loan_amount > 200000000)
        newErrors.loan_amount = newErrors.loan_amount =
          "Loan amount should be Min 5 lacs and Max 20 Crs";
      if (!loan_amount || loan_amount === "")
        newErrors.loan_amount = "The Loan Amount field is required.";

      return newErrors;
    };

    const handleSubmit = async (e) => {
      e.preventDefault();

      const newErrors = findFormErrors();
      if (Object.keys(newErrors).length > 0) {
        this.setState({ errors: newErrors });
      } else {
        let body = encryptDataToArray({
          mobile: form.mobile_number,
        });
        axios
          .post(`${BASE_URL}/send_otp`, body, { headers: HEADER_AUTH })
          .then((res) => {
            // alert(res?.data?.data?.otp);
          })
          .catch((error) => {
            console.error(error);
          });

        this.setState({ doVerifyOtp: true });
      }
    };

    const handleVerifyOtp = async () => {
      let verify_otp = false;
      let body = encryptDataToArray({
        otp: form.otp,
        mobile: form.mobile_number,
      });
      await axios
        .post(`${BASE_URL}/verify_otp`, body, { headers: HEADER_AUTH })
        .then((res) => {
          let info = decryptDataFromArray(res.data);
          if (info.success === true) {
            verify_otp = true;
          } else {
            alert("Please enter correct OTP.");
          }
        })
        .catch((error) => {
          console.error(error);
        });
      if (verify_otp === true) {
        this.setState({ show_loader: true });

        let paramsURL = window.location.href.toString().split("?")[1]
          ? window.location.href.toString().split("?")[1]
          : null;
        let UTM_Source = "";
        let UTM_Medium = "";
        let UTM_Campaign = "";
        let UTM_Content = "";
        let REQUEST_Id = "";
        if (paramsURL) {
          const queryParams = new URLSearchParams("?" + paramsURL);
          UTM_Source = queryParams.get("utm_source");
          UTM_Medium = queryParams.get("utm_medium");
          UTM_Campaign = queryParams.get("utm_campaign");
          UTM_Content = queryParams.get("utm_content");
          REQUEST_Id = queryParams.get("request_id");
        }

        var bodyFormData = new FormData();
        bodyFormData.append("full_name", form.full_name);
        bodyFormData.append("email", form.email);
        // bodyFormData.append("product", form.product);
        bodyFormData.append("mobile_number", form.mobile_number);
        bodyFormData.append("state", form.state);
        bodyFormData.append("city", form.city);
        bodyFormData.append("loan_amount", form.loan_amount);
        bodyFormData.append("isChecked", isChecked);
        bodyFormData.append("UTM_Source", UTM_Source);
        bodyFormData.append("UTM_Medium", UTM_Medium);
        bodyFormData.append("UTM_Campaign", UTM_Campaign);
        bodyFormData.append("UTM_Content", UTM_Content); // "some_value"
        bodyFormData.append("REQUEST_Id", REQUEST_Id);
        await axios
          .post(`${BASE_URL}/call_back_form`, bodyFormData, {
            headers: HEADER_AUTH,
          })
          .then((res) => {
            localStorage.setItem("call_back_thank_you_flag", true);
            window.location.href = "/thank-you";
          });
      }
    };
    // console.log(form);
    // console.log('form');

    const handleResendOtp = () => {
      let body = encryptDataToArray({
        mobile: form.mobile_number,
      });
      console.log(
        "---------------------otp-verification----------------------"
      );
      axios
        .post(`${BASE_URL}/send_otp`, body, { headers: HEADER_AUTH })
        .then((res) => {
          let info = decryptDataFromArray(res.data);
          console.log("res", info);
          localStorage.setItem("callback_data_otp", info.data.otp);
          console.log("res", info.data.otp);
        })
        .catch((error) => {
          console.error(error);
        });
      this.setState({ doVerifyOtp: true });
    };

    const { isExpanded } = this.state;

    return (
      <>
        <div id="quote" className="section request-callback multiplecomp">
          <header className="entry-title text-center">
            <h2 className="title-head">{t("Request a Call Back!")}</h2>
            <p>
              {t(
                "Fill up the Form and Our Customer Care will contact you shortly"
              )}
            </p>
          </header>
          <div className="request-form">
            {!doVerifyOtp ? (
              <Form>
                <Row>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <img src="/img/user-ico.png" alt="full_name" />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        maxLength={50}
                        placeholder={t("Name (as on PAN Card)") + "*"}
                        name="full_name"
                        onChange={(e) =>
                          setField(e.target.name, e.target.value)
                        }
                        isInvalid={!!errors.full_name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(errors.full_name)}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <img src="/img/mobile-ico.png" alt="mobile_number" />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="mobile_number"
                        onChange={(e) =>
                          setField(e.target.name, e.target.value)
                        }
                        placeholder={t("Mobile Number") + "*"}
                        minLength={10}
                        maxLength={10}
                        isInvalid={!!errors.mobile_number}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(errors.mobile_number)}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <img src="/img/email-ico.png" alt="email" />
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        onChange={(e) =>
                          setField(e.target.name, e.target.value)
                        }
                        placeholder={t("Enter Email")}
                        isInvalid={!!errors.email}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(errors.email)}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {/* <Col md={6} lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <img src="/img/state-ico.png" alt="state" />
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="product"
                        onChange={(e) => {
                          setField(e.target.name, e.target.value);
                        }}
                      >
                        <option value="">{t("Select Product")}*</option>
                        <option value="Home Loan">{t("Home Loan")}</option>
                        <option value="Loan Against Property">
                          {t(" Loan Against Property")}
                        </option>
                      </Form.Control>
                      <span className="show_err">{t(errors.product)}</span>
                    </Form.Group>
                  </Col> */}
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <img src="/img/state-ico.png" alt="state" />
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="state"
                        onChange={(e) => {
                          setField(e.target.name, e.target.value);
                          this.setState({ selected_state: e.target.value });
                        }}
                      >
                        <option value="">{t("Select State")}*</option>
                        {states?.map((item, index) => {
                          return parseInt(selected_state) ===
                            parseInt(item.id) ? (
                            <option value={item.id} selected key={index}>
                              {item.state_name}
                            </option>
                          ) : (
                            <option value={item.id} key={index}>
                              {item.state_name}
                            </option>
                          );
                        })}
                      </Form.Control>
                      <span className="show_err">{t(errors.state)}</span>
                      {/* <Form.Control.Feedback type="invalid">
                        {errors.state}
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <img src="/img/city-ico.png" alt="city" />
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="city"
                        onChange={(e) => {
                          setField(e.target.name, e.target.value);
                          this.setState({ selected_city: e.target.value });
                        }}
                      >
                        <option value="">{t("Select City")}*</option>
                        {cities?.map((item, index) => {
                          return parseInt(this.state.selected_state) ===
                            parseInt(item.state_id) ? (
                            parseInt(selected_city) === parseInt(item.id) ? (
                              <option value={item.id} selected key={index}>
                                {item.city_name}
                              </option>
                            ) : (
                              <option value={item.id} key={index}>
                                {item.city_name}
                              </option>
                            )
                          ) : null;
                        })}
                      </Form.Control>
                      <span className="show_err">{t(errors.city)}</span>
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <img src="/img/loan-ico.png" alt="loan_amount" />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="loan_amount"
                        maxLength={11}
                        value={form?.loan_amount}
                        onChange={(e) =>
                          handleChangeLoanAmount(e.target.name, e.target.value)
                        }
                        placeholder={t("Loan Amount") + "*"}
                        isInvalid={!!errors.loan_amount}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(errors.loan_amount)}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <p className="d-block text-center mt-4">
                      <div className="checkbox-wrapper d-inline-block">
                        <label className="d-inline">
                          <input
                            className="mr-2 d-inline-block"
                            type="checkbox"
                            isInvalid={!!errors.isChecked}
                            defaultChecked={isChecked ? isChecked : false}
                            onChange={(e) => {
                              setField(e.target.name, !this.state.isChecked);
                              this.setState({
                                isChecked: !this.state.isChecked,
                              });
                            }}
                            name="isChecked"
                            id="flexCheckDefault"
                          />
                        </label>
                      </div>
                        <div
                          className="d-inline"
                          dangerouslySetInnerHTML={{
                            __html: t("request_call_back_contents"),
                          }}
                        ></div>
                      {/* </a> */}

                      <div className="d-inline text-danger ml-2">
                        <br></br>
                        {t(errors.isChecked)}
                      </div>
                    </p>

                    {/* <small className="d-block text-center">
                      {t("request_call_back_content")}
                    </small> */}
                  </Col>
                  <Col className="text-center m-2" md={12}>
                    <Button
                      as="input"
                      variant="white"
                      type="submit"
                      value={t("Submit")}
                      onClick={handleSubmit}
                    />
                  </Col>
                </Row>
                <div className="content-sec">
                  <p>
                    <strong>
                      *{" "}
                      {t(
                        "By submitting this form, I agree to the following Terms & Conditions:"
                      )}
                    </strong>
                  </p>
                  <p>
                    1.{" "}
                    <div
                      className="d-inline"
                      dangerouslySetInnerHTML={{
                        __html: t(
                          "I expressly consent to and authorize Hero Housing Finance Limited (‘HHFL’) to collect, use, and share my Sensitive personal data and financial information, as defined in the Information Technology (Reasonable security practices and procedures and sensitive personal data or information) Rules, 2011, as may be amended from time to time for the purpose of assessing my eligibility for the loan, evaluating my creditworthiness and credit score, and disclosing information to third-party, credit bureaus, financial institutions, HHFL’s representatives, and other relevant entities as necessary, in accordance with HHFL’s Customer Data Privacy Policy available at <a href='https://www.herohousingfinance.com/uploads/pdf/customer-data-privacy-policy(09-07-2024).pdf' className='d-inline link-style' target='_blank'> <strong>www.herohousingfinance.com.</strong></a>"
                        ),
                      }}
                    ></div>
                    {/* {t(
                      "I expressly consent to and authorize Hero Housing Finance Limited (‘HHFL’) to collect, use, and share my Sensitive personal data and financial information, as defined in the Information Technology (Reasonable security practices and procedures and sensitive personal data or information) Rules, 2011, as may be amended from time to time for the purpose of assessing my eligibility for the loan, evaluating my creditworthiness and credit score, and disclosing information to third-party, credit bureaus, financial institutions, HHFL’s representatives, and other relevant entities as necessary, in accordance with HHFL’s Customer Data Privacy Policy available at"
                    )}{" "}
                    <a
                      href="https://www.herohousingfinance.com/uploads/pdf/customer-data-privacy-policy(09-07-2024).pdf"
                      className="d-inline link-style"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <u>
                        <strong>www.herohousingfinance.com.</strong>
                      </u>
                    </a> */}
                  </p>

                  {isExpanded && (
                    <>
                      <p>
                        2.{" "}
                        {t(
                          "By providing my personal/contact details, I agree that I am interested in availing the loan facility from HHFL. I agree that HHFL, can contact me either electronically or by phone, to understand my interest in the selected loan products and to fulfill my application or solicit related products to me. I expressly waive any Do Not Call registrations on my phone/mobile numbers for contacting me for this purpose."
                        )}
                      </p>
                      <p>
                        3.{" "}
                        {t(
                          "I acknowledge that I can withdraw this consent at any time as per the Data Privacy policy of the Company."
                        )}
                      </p>
                      <p>
                        4.{" "}
                        {t(
                          "I understand that HHFL is not responsible for any consequences arising from inaccurate information or my failure to receive notifications due to the withdrawal of my consent."
                        )}
                      </p>
                      <p>
                        5.{" "}
                        {t(
                          "I understand that HHFL is servicing customers at the locations listed in the 'Select city' dropdown menu."
                        )}
                      </p>
                    </>
                  )}

                  <button
                    className={
                      isExpanded ? "expanded showmore" : "collapsed showmore"
                    }
                    onClick={this.toggleContent}
                  >
                    {isExpanded ? "Show Less" : "Show More"}

                    {/* Conditionally render SVG based on state */}
                    {isExpanded ? (
                      <svg
                        className="w-6 h-6 text-gray-800 dark:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="m5 15 7-7 7 7"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="w-6 h-6 text-gray-800 dark:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="m19 9-7 7-7-7"
                        />
                      </svg>
                    )}
                  </button>
                </div>
              </Form>
            ) : (
              <Form>
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <img src="/img/mobile-ico.png" alt="Icon" />
                      </Form.Label>
                      <Form.Control
                        type="number"
                        max={999999}
                        name="otp"
                        onChange={(e) => {
                          setField(e.target.name, e.target.value);
                        }}
                        placeholder={t("Enter OTP")}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <div className="text-center">
                      <Button
                        as="input"
                        variant="white"
                        type="button"
                        value={
                          this.state?.show_loader
                            ? t("Please wait...")
                            : t("Verify OTP")
                        }
                        className="mr-3"
                        onClick={handleVerifyOtp}
                      />
                      <Button
                        as="input"
                        variant="white"
                        type="button"
                        value={t("Resend OTP")}
                        onClick={handleResendOtp}
                      />
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </div>
        </div>
      </>
    );
  }
}
